// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import AlertsComponent from 'Components/Alerts/Alerts';
import useNotifications from 'Hooks/useNotifications';
import useModals from 'Hooks/useModals';
import useOutsideClick from 'Hooks/useOutsideClick';

const Alerts = memo(() => {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const isVisible = useOutsideClick(ref);
  const handleOnToggle = () => setOpen(prevOpen => !prevOpen);
  const notificationsCtx = useNotifications();
  const modalsCtx = useModals();
  const location = useLocation();
  const navigate = useNavigate();

  const handleOnOpen = id => {
    const notification = notificationsCtx.data.find(item => item.messageId === id);
    if (notification) {
      modalsCtx.setState(modalsCtx.modalState.NOTIFICATIONS.key, {
        open: true,
        notifications: [notification]
      });
    }
  };

  useEffect(() => {
    setOpen(isVisible);
  }, [isVisible]);

  const handleNavigateToNotifications = targetId => {
    const isDashboardPage = location.pathname === '/';

    const scrollToSection = () => {
      const section = document.getElementById(targetId);
      if (section) section.scrollIntoView({ behavior: 'smooth' });
    };

    if (isDashboardPage) {
      scrollToSection();
    } else {
      navigate('/', { replace: false });
      setTimeout(() => scrollToSection(), 1000);
    }
  };

  return (
    <AlertsComponent
      ref={ ref }
      open={ open }
      onToggle={ handleOnToggle }
      notifications={ notificationsCtx.data || [] }
      loading={ notificationsCtx.loading }
      onOpen={ handleOnOpen }
      onNavigateToNotifications={ handleNavigateToNotifications }
    />
  );
});

Alerts.displayName = 'AlertsContainer';

export default Alerts;
